import { render, staticRenderFns } from "./nav-setting.vue?vue&type=template&id=58320159&scoped=true"
import script from "./nav-setting.vue?vue&type=script&lang=js"
export * from "./nav-setting.vue?vue&type=script&lang=js"
import style1 from "./nav-setting.vue?vue&type=style&index=1&id=58320159&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58320159",
  null
  
)

export default component.exports